import { createCrudSlice } from '../createCrudSlice';
import couponsService from '@/services/coupons.service';

const { reducer, thunks } = createCrudSlice('coupons', couponsService);
export const { fetchList: fetchCoupons, createItem: createCoupon, updateItem: updateCoupon, deleteItem: deleteCoupon } = thunks;
export default reducer;
